/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_Unlink_DoneInputs */

const cs_settings_meta_unlink_done = /** @type {(inputs: Settings_Meta_Unlink_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobní Meta odpojena`)
};

const en_settings_meta_unlink_done = /** @type {(inputs: Settings_Meta_Unlink_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Meta unlinked`)
};

/**
* | output |
* | --- |
* | "Personal Meta unlinked" |
*
* @param {Settings_Meta_Unlink_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_unlink_done = /** @type {((inputs?: Settings_Meta_Unlink_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_Unlink_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_unlink_done(inputs)
	return cs_settings_meta_unlink_done(inputs)
});